import dayjs from "dayjs";

const formatTimestamp = (timestamp?: string, format = "DD MMM YYYY") => {
    if (!timestamp || !dayjs(timestamp).isValid()) {
        return null;
    }

    return dayjs(timestamp, "YYYY-MM-DD HH:mm:ss:SSS").format(format);
};

export const formatTime = (timestamp?: string) => {
    if (!timestamp || !dayjs(timestamp).isValid()) {
        return null;
    }

    return dayjs(timestamp, "YYYY-MM-DD HH:mm:ss:SSS").format("HH:mm");
};

export const formatTimestampForBlogPost = (timestamp?: string) => {
    if (!timestamp || !dayjs(timestamp).isValid()) {
        return null;
    }

    return dayjs(timestamp, "YYYY-MM-DD HH:mm:ss:SSS").format("MMM DD, YYYY");
};

export default formatTimestamp;
